import SeoHead from '../components/SeoHead'
import PageHeader from '../components/PageHeader'
import RelatedPages from '../components/RelatedPages'
import type { NavLeaf } from '../nav'

interface Props {
  leaf: NavLeaf
}

export default function MdxPage({ leaf }: Props) {
  const Content = leaf.Component
  return (
    <>
      <SeoHead frontmatter={leaf.frontmatter} path={leaf.slug} />
      <PageHeader
        title={leaf.frontmatter.title}
        eyebrow={leaf.frontmatter.category}
      />
      <article>
        <Content />
      </article>
      <RelatedPages currentSlug={leaf.slug} />
    </>
  )
}
